<template>
  <div id="carousel">
    <div class="carousel">
      <el-carousel height="540px" @change="carouselChange" ref="carousel">
        <el-carousel-item v-for="(item, index) in pageData.banner_data" :key="index">
          <a
            class="carousel-item"
            :href="item.url || '#'"
            v-bind:style="{ backgroundImage: 'url(' + item.picture + ')' }"
          ></a>
        </el-carousel-item>
      </el-carousel>
      <div class="float">
        <div class="float-box">
          <div class="left">
            <!-- 物流知识 -->
            <div class="box-title">物流知识</div>
            <div
              class="nav-list"
              v-for="(item, index) in pageData.category_data"
              :key="index"
              v-show="index < 3"
            >
              <div class="nav-box">
                <div class="list-title">
                  <a :href="item.url" target="_blank" v-text="item.category_name">分类一</a>
                </div>
                <div class="list-item">
                  <div
                    class="item-a"
                    v-for="(child, child_index) in item.child_data"
                    :key="child_index"
                    v-show="child_index < 6"
                  >
                    <a :href="child.url" target="_blank" v-text="child.category_name">子分类一</a>
                  </div>
                </div>
              </div>
            </div>

            <!-- 学习培训 -->
            <div class="box-title class-title" v-if="pageData.study_type">学习培训</div>
            <!-- <div
              class="nav-list"
              v-for="(item, index) in pageData.study_type"
              :key="index"
              v-show="index < 3"
            >
              <div class="nav-box">
                <div class="list-title">
                  
                  <a  :href="'/studyClassify/index.html?name='+item.name+'&num='+item.moduleno" target="_blank" v-text="item.name">分类一</a>
                </div>
                <div class="list-item">
                  <div
                    class="item-a"
                    v-for="(child, child_index) in item.child"
                    :key="child_index"
                    v-show="child_index < 6"
                  >
                    <a :href="'/studyClassify/index.html?name='+child.name+'&num='+child.moduleno" target="_blank" v-text="child.name">子分类一</a>
                  </div>
                </div>
              </div>
            </div>-->
            <div class="list-item">
              <div
                class="item-a"
                v-for="(child, child_index) in pageData.study_type"
                :key="child_index"
              >
                <a
                  :href="'/studyClassify/index.html?name='+child.name+'&num='+child.moduleno"
                  target="_blank"
                  v-text="child.name"
                >子分类一</a>
              </div>
            </div>
          </div>

          <div class="center">
            <div
              class="recommend"
              v-for="(item, index) in pageData.hot_ency_data"
              v-on:mouseenter="Mouseenter(index)"
              :key="index"
              v-bind:style="{
                borderColor:
                  index === centerSelect
                    ? 'rgba(37, 162, 87, 0.5)'
                    : 'rgba(0, 0, 0, 0.1)'
              }"
            >
              <a
                target="_blank"
                class="recommend-item"
                :href="item.url"
                v-bind:style="{ backgroundImage: 'url(' + item.picture + ')' }"
              ></a>
              <div class="badge" v-text="item.score">7.5</div>
              <div class="link">
                <div class="link-a">
                  <a target="_blank" :href="item.url" v-text="item.title">我是热点标题标题121</a>
                </div>
                <div class="link-see-num">
                  <i class="iconfont icon-biyan"></i>
                  {{ item.click_times }}
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <!-- 文库统计 -->
            <div class="right-box">
              <div class="box-title">文库</div>
              <div class="box-num" v-text="pageData.lib_stats_data.total + ' 个'">15,492,499 个</div>
              <div class="box-flex">
                <div>浏览</div>
                <div v-text="pageData.lib_stats_data.browse_times">6,571,345</div>
              </div>
              <div class="box-flex">
                <div>下载</div>
                <div v-text="pageData.lib_stats_data.download_times">6,571,345</div>
              </div>
            </div>
            <!-- 知识点统计 -->
            <div class="right-box">
              <div class="box-title">知识点</div>
              <div class="box-num" v-text="pageData.ency_stats_data.total + ' 个'">185,492,499 条</div>
              <div class="box-flex">
                <div>编写</div>
                <div v-text="pageData.ency_stats_data.edit_times">6,571,345</div>
              </div>
              <div class="box-flex">
                <div>浏览</div>
                <div v-text="pageData.ency_stats_data.browse_times">6,571</div>
              </div>
            </div>
            <!-- 课程统计 -->
            <div class="right-box">
              <div class="box-title">课程</div>
              <div class="box-num" v-text="pageData.class_stats_data.total + ' 个'">0 个</div>
              <div class="box-flex">
                <div>学习</div>
                <div v-text="pageData.class_stats_data.learn_times">0</div>
              </div>
              <div class="box-flex">
                <div>测验</div>
                <div v-text="pageData.class_stats_data.test_times">0</div>
              </div>
            </div>

            <div class="create-btn">
              <a href="javascript:;" @click="dialog = true">我要创建 >></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="请选择创建类型" width="300px" center :visible.sync="dialog">
      <div class="dialog">
        <div>
          <el-button type="primary" round @click="toPage('/library/new.do')">创建文库</el-button>
        </div>
        <div style="margin:25px 0">
          <el-button type="success" round @click="toPage('/ency/new.do')">创建百科</el-button>
        </div>
        <div v-if="Number(pageData.lecture) === 1">
          <el-button type="warning" round @click="toPage('/user/?p=new-course')">创建课程</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    pageData: Object
  },
  data() {
    return {
      carouselSelect: 0,
      centerSelect: 0,
      dialog: false
    };
  },
  methods: {
    carouselChange(event) {
      this.carouselSelect = event;
    },
    Mouseenter(index) {
      this.centerSelect = index;
    },
    toPage(url) {
      window.open(url);
      this.dialog = false;
    }
  }
};
</script>
<style scope lang="scss">
@import "./../../../assets/iconfont/iconfont.css";
@mixin theme-color-a {
  a:hover {
    color: #009944;
  }
}
.dialog {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.carousel {
  position: relative;
  .is-active .el-carousel__button {
    background-color: #009944;
  }
  .el-carousel__arrow {
    display: none;
  }
  .carousel-item {
    height: 100%;
    width: 100%;
    display: block;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    position: relative;
    z-index: 1;
  }
  .float {
    width: 100%;
    height: 540px;
    position: absolute;
    left: 0;
    top: 0;
    .float-box {
      width: 1200px;
      height: 540px;
      margin: 0 auto;
      position: relative;
      .left {
        width: 180px;
        height: 540px;
        position: absolute;
        left: 0;
        top: 0;
        background-color: #ffffff;
        z-index: 2;
        .nav-list {
          // height: 95px;
          box-sizing: border-box;
          // position: relative;
          .nav-box {
            // position: absolute;
            // left: 0;
            // top: 30%;
            // transform: translateY(-50%);
            // margin: auto 0;
            // width: 100%;
            .list-title {
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 35px;
              letter-spacing: 0px;
              color: #000000;
              margin-left: 30px;
              font-weight: bold;
              a {
                font-size: 16px;
                // line-height: 48px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              a:hover {
                color: #009944;
              }
            }
          }
        }
        .list-item {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          .item-a {
            display: block;
            width: 50%;
            box-sizing: border-box;
            margin: 5px 0;
            a {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 14px;
              letter-spacing: 0px;
              color: #333333;
              max-height: 28px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            a:hover {
              color: #009944;
            }
          }
          .item-a:nth-child(2n) {
            padding-left: 11px;
            padding-right: 30px;
          }
          .item-a:nth-child(2n + 1) {
            padding-left: 30px;
            padding-right: 11px;
          }
        }
        // .nav-list:nth-child(2) {
        //   box-sizing: border-box;
        //   border-top: 1px solid #f5f5f5;
        //   border-bottom: 1px solid #f5f5f5;
        // }
      }
      .box-title {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 48px;
        letter-spacing: 0px;
        color: #000000;
        font-weight: bold;
        text-align: center;
      }
      .class-title {
        // margin-top: -20px;
        margin-top: 20px;
        border-top: 1px solid #f5f5f5;
      }
      .right {
        width: 215px;
        padding: 0 0 20px 0;
        background-color: #ffffff;
        border-radius: 2px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;

        .right-box {
          // height: 165px;
          text-align: center;

          .box-num {
            font-size: 18px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 20px;
            letter-spacing: 0px;
            color: #000000;
            margin-bottom: 10px;
          }
          .box-flex {
            width: 100%;
            display: flex;
            padding: 0 0 5px 0;
          }
          .box-flex > div {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 28px;
            letter-spacing: 0px;
            color: #000000;
          }
          .box-flex > div:nth-child(2n + 1) {
            text-align: right;
            margin-left: 50px;
          }
          .box-flex > div:nth-child(2n) {
            min-width: 80px;
            text-align: center;
            margin-left: 10px;
          }
        }
        .right-box {
          border-bottom: 1px solid rgba(215, 226, 229, 0.5);
        }
        .right-box:nth-last-child(2) {
          border: none;
        }
        .create-btn {
          width: 185px;
          text-align: center;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 45px;
          letter-spacing: 0px;
          color: #ffffff;
          background-color: #25a257;
          border-radius: 23px;
          border: solid 1px #4caa6c;
          margin: 0 15px;
          overflow: hidden;
          margin-top: 15px;
          a {
            width: 185px;
            color: #ffffff;
            line-height: 45px;
          }
        }
      }
      .center {
        width: 773px;
        height: 120px;
        z-index: 2;
        position: absolute;
        left: 196px;
        bottom: 25px;
        display: flex;
        justify-content: space-between;
        .recommend {
          width: 182px;
          height: 120px;
          position: relative;
          box-sizing: border-box;
          border: solid 2px rgba(0, 0, 0, 0.15);
          .recommend-item {
            height: 100%;
            width: 100%;
            display: block;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: 50%;
            position: relative;
            z-index: 1;
          }
          .badge {
            width: 40px;
            height: 27px;
            font-size: 16px;
            line-height: 27px;
            text-align: center;
            color: #ffffff;
            z-index: 1;
            background-color: #eb732c;
            border-radius: 8px 0 0 18px;
            position: absolute;
            top: 0;
            right: 0;
          }
          .link {
            width: 100%;
            z-index: 1;
            background-color: rgba(0, 0, 0, 0.41);
            display: flex;
            justify-content: space-between;
            position: absolute;
            left: 0;
            bottom: 0;
            box-sizing: border-box;
            padding: 0 10px;
            .link-a {
              max-width: 95px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              color: #ffffff;
              a {
                font-size: 12px;
                line-height: 30px;
                letter-spacing: 0px;
                color: #ffffff;
              }
              a:hover {
                color: #00e265;
              }
            }
            .link-see-num {
              line-height: 30px;
              font-size: 12px;
              color: #fffefe;
              .iconfont {
                margin-right: 5px;
                line-height: 30px;
                font-size: 12px;
                color: #fffefe;
              }
            }
          }
        }
      }
    }
  }
}
</style>
